import React from 'react';
import { useApplicationSize } from '@anwb/providers-application';
import { ImageErrorContainer, ImageErrorIcon, ImageErrorMessage, } from './styles/image-error.styled';
export const ImageError = ({ className, dataTest, inline, width, alignment, coverContainer, }) => {
    const applicationSize = useApplicationSize();
    const typographyVariant = applicationSize === 'large' ? 'component-subtitle' : 'label-text';
    return (React.createElement(ImageErrorContainer, { className: className, "data-test": dataTest, "$inline": inline, "$width": width, "$alignment": alignment, "$coverContainer": coverContainer },
        React.createElement(ImageErrorIcon, { "aria-hidden": "true" }),
        React.createElement(ImageErrorMessage, { variant: typographyVariant, tagName: "span" }, "Geen afbeelding beschikbaar")));
};
//# sourceMappingURL=ImageError.js.map